import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()

export class IqaRecordFormService {

  apiUrl: string;
  token: string;

  constructor(private http: HttpClient) {
    this.token = localStorage.getItem('access_token');
  }

  getOptionsWithAccessToken() {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token);
    let options = { headers: headers };
    return options;
  }

  public createNewIqaRecord(traineeId: string, pot: number, staffid: number, values: any): Observable<any>{
    if(!traineeId) return null;

    const url = `${environment.API_URL}CreateNewIqaRecord`;
    const options = this.getOptionsWithAccessToken();

    values.iqaRecordId = 0;
    values.traineeId = traineeId;
    values.pot = pot;
    values.staffId = staffid;
    values.units = values.selectedUnitsArray;

    return this.http.post<any>(url, values, options);
  }



  public updateIqaRecord(traineeId: string, pot: number, staffid: number, values: any): Observable<any>{
    if(!traineeId) return null;

    const url = `${environment.API_URL}UpdateIqaRecord`;
    const options = this.getOptionsWithAccessToken();

    values.traineeId = traineeId;
    values.pot = pot;
    values.staffId = staffid;
    values.units = values.selectedUnitsArray;

    return this.http.post<any>(url, values, options);
  }

  public getIqaRecord(iqaRecordId): Observable<any> {
    const url = `${environment.API_URL}GetIqaRecord?iqaRecordId=${iqaRecordId}`;
    const options = this.getOptionsWithAccessToken();
    return this.http.get(url, options);
  }

  public getUnits(laimref: string): Observable<any> {
    if(!laimref) return null;

    const url = `${environment.API_URL}GetUnits?laimref=${laimref}`;
    const options = this.getOptionsWithAccessToken();
    return this.http.get(url, options);
  }

  public submitForIQA(values): Observable<any> {
    const url = `${environment.API_URL}SubmitForIQA`;
    const options = this.getOptionsWithAccessToken();
    return this.http.post(url, values, options);
  }

  public removeSubmitForIQA(submissionId: number): Observable<any> {
    const url = `${environment.API_URL}RemoveSubmitForIQA/${submissionId}`;
    const options = this.getOptionsWithAccessToken();
    return this.http.delete(url, options);
  }


}
